import { tns } from 'tiny-slider/src/tiny-slider';

const options = {
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    edgePadding: 25,
    gutter: 0,
    items: 1,
    loop: false,
    mouseDrag: true,
    nav: false,
    preventScrollOnTouch: 'auto',
    rewind: true,
    slideBy: 1,
    speed: 600,
    swipeAngle: 30,
    responsive: {
        376: {
            edgePadding: 50,
            gutter: 0,
        },
        576: {
            disable: true,
        },
    },
};

function init() {
    const elements = document.querySelectorAll('[data-slider="faculty-list"]');

    [...elements].forEach((element) => {
        tns({
            ...options,
            container: element.querySelector('.faculty-wrapper'),
        });
    });
}

export default {
    init,
};
